import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { OrganizersPageViewProps } from './organizerspage.props';

const OrganizersPageView: React.FC<OrganizersPageViewProps> = ({ organizers, loading, navigate }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Организатори</h1>
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <Card key={i}>
                <CardContent className="p-6">
                  <div className="flex items-center space-x-4 mb-4">
                    <Skeleton className="w-16 h-16 rounded-full" />
                    <div className="flex-1 space-y-2">
                      <Skeleton className="h-5 w-3/4" />
                      <Skeleton className="h-4 w-1/2" />
                    </div>
                  </div>
                  <Skeleton className="h-16 w-full" />
                </CardContent>
              </Card>
            ))}
          </div>
        ) : organizers.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {organizers.map((organizer) => (
              <Card
                key={organizer.id}
                className="cursor-pointer hover:shadow-lg transition-all duration-300"
                onClick={() => navigate(`/organizers/${organizer.id}`)}
              >
                <CardContent className="p-6">
                  <div className="flex items-center space-x-4 mb-4">
                    <img src={organizer.logo} alt={organizer.name} className="w-16 h-16 rounded-full object-cover" />
                    <div className="flex-1">
                      <h3 className="font-bold text-lg text-gray-900 hover:text-blue-600 transition-colors">
                        {organizer.name}
                      </h3>
                    </div>
                  </div>
                  <p className="text-gray-700 text-sm line-clamp-3">{organizer.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        ) : (
          <p className="text-gray-600 text-center py-12">Нема пронајдено организатори.</p>
        )}
      </div>
    </div>
  );
};

export default OrganizersPageView;
